import UpdateAccountForm from './UpdateAccountForm';
export default UpdateAccountForm;